import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the table bets report view.
 */
export default class tableBetsReportView extends JetView {
    /**
     * Configures the view.
     * @returns {Object} Configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const cur_user = this.getParam('user', true); // Current user parameter

        // Custom data filter for summing tree column
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                refresh: function (master, node, value) {
                    var result = 0; // Initialize result
                    var resultFormat = 0; // Initialize formatted result
                    master.data.each(function (obj) {
                        if (obj.$level == 1) result += obj[value.columnId]; // Sum values at level 1
                    });
                    // Format result based on column ID
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.intFormat(result);
                    } else {
                        resultFormat = webix.i18n.priceFormat(result);
                    }
                    node.firstChild.innerHTML = resultFormat; // Update node with formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Extend existing summColumn filter
        );

        return {
            view: 'treetable', // Treetable view
            id: 'treetable', // ID of the treetable
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            scheme: {
                $group: {
                    by: 'UserName', // Grouping by UserName
                    map: {
                        UserName: ["<span style='font-weight:bold;'>Total:</span>", 'string'],
                        Amount: ['Amount', 'sum'], // Sum of Amount
                        WinningAmount: ['WinningAmount', 'sum'], // Sum of WinningAmount
                        Tax: ['Tax', 'sum'], // Sum of Tax
                        WinningAmountTotal: ['WinningAmountTotal', 'sum'], // Sum of WinningAmountTotal
                    },
                },
            },
            columns: [
                {
                    id: 'UserName', // Column ID
                    header: _('UserName'), // Column header
                    width: 200, // Column width
                    template: function (obj, common) {
                        if (obj.$group) return common.treetable(obj, common) + obj.value; // Render group row
                        return obj.UserName; // Render user name
                    },
                    footer: 'Total:', // Footer content
                },
                {
                    id: 'detailTittle', // Column ID for details
                    header: '', // No header
                    width: 50, // Column width
                    height: 25, // Column height
                    tooltip: _('Detalles'), // Tooltip text
                    template: function (obj) {
                        if (obj.$level == 1) {
                            return ''; // No details for level 1
                        } else {
                            if (obj.$level == 2) {
                                return "<span class='webix_icon wxi-close details'></span>"; // Details icon for level 2
                            }
                        }
                    },
                },
                { id: 'Id', header: _('Ticket Id'), width: 100, sort: 'int' }, // Ticket ID column
                { id: 'UserId', header: _('Usuario'), width: 100, sort: 'int' }, // User ID column
                {
                    id: 'State', // State column
                    header: _('Estado'), // Column header
                    options: [
                        { id: '', value: _('None') }, // No state
                        { id: 'A', value: _('Abierto') }, // Open state
                        { id: 'C', value: _('Cancelado') }, // Canceled state
                        { id: 'I', value: _('Cerrado') }, // Closed state
                    ],
                },
                { id: 'Date', header: 'Fecha', width: 150, sort: 'int' }, // Date column
                {
                    id: 'Amount', // Amount column
                    header: _('Valor'), // Column header
                    format: webix.i18n.priceFormat, // Formatting function
                    exportType: 'number', // Export type
                    width: 100, // Column width
                    sort: 'int', // Sorting type
                    footer: { content: 'summTreeColumn' }, // Footer content
                },
                {
                    id: 'WinningAmount', // Winning Amount column
                    header: _('Premios'), // Column header
                    format: webix.i18n.priceFormat, // Formatting function
                    exportType: 'number', // Export type
                    width: 100, // Column width
                    sort: 'int', // Sorting type
                    footer: { content: 'summTreeColumn' }, // Footer content
                },
                {
                    id: 'Tax', // Tax column
                    header: _('Impuesto'), // Column header
                    format: webix.i18n.priceFormat, // Formatting function
                    exportType: 'number', // Export type
                    width: 100, // Column width
                    sort: 'int', // Sorting type
                    footer: { content: 'summTreeColumn' }, // Footer content
                },
                {
                    id: 'WinningAmountTotal', // Total Winning Amount column
                    header: _('Premio Total'), // Column header
                    format: webix.i18n.priceFormat, // Formatting function
                    exportType: 'number', // Export type
                    width: 100, // Column width
                    sort: 'int', // Sorting type
                    footer: { content: 'summTreeColumn' }, // Footer content
                },
                { id: 'Odds', header: _('Odds'), width: 100, sort: 'int' }, // Odds column
                { id: 'UserIP', header: _('IP'), width: 120, sort: 'int' }, // User IP column
            ],
            onClick: {
                details: function (euv, id) {
                    var item = this.getItem(id); // Get clicked item
                    this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
                },
            },
            tooltip: true, // Enable tooltips
            footer: true, // Enable footer
            math: true, // Enable math calculations
            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
            pager: 'pagerA', // Pager ID
            url:
                devConfig.geturlApi() + // API URL
                'null/Report/GetBetHistory?FromId=' +
                cur_user +
                '&', // Query parameter for current user
        };
    }

    /**
     * Initializes the grid with event listeners.
     * @param {Object} grid - The grid instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        const cur_user = this.getParam('user', true); // Current user parameter
        var url = grid.data.url; // Grid URL
        var filter = ''; // Initialize filter

        // Event listener for filtering bets report
        this.on(this.app, 'betsReport:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert object filter to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'end') {
                                    var d = new Date(object2[j][1]); // Parse end date
                                    var dateFrom =
                                        'MaxCreatedLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format end date
                                    string1 = string1 + '&' + dateFrom; // Add MaxCreatedLocal to query
                                } else {
                                    if (object2[j][0] === 'start') {
                                        var d = new Date(object2[j][1]); // Parse start date
                                        var dateTo =
                                            'MinCreatedLocal=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format start date
                                        string1 = string1 + '&' + dateTo; // Add MinCreatedLocal to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&FromId=' + cur_user; // Add current user to query
            grid.clearAll(); // Clear grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load filtered data
            filter = string1; // Update filter
        });

        // Event listener for sorting
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event listener for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&FromId=' + id, // Load data for selected player
            );
        });
    }
}

// FILE DOCUMENTED
